/**
 * Shared inline CSS for every standalone HTML file a module writes to disk
 * (a Teams chat transcript, a OneNote page, any module's index.html).
 *
 * Centralised so the same look (and the same light/dark handling) doesn't
 * have to be hand-copied into each render.ts — previously Teams and OneNote
 * each carried their own near-identical copy. Exported HTML is a standalone
 * artifact with no access to the app's own styles.css, so this still has to
 * be inlined into every page rather than linked.
 */

export const PAGE_BASE_CSS = `
    body { font: 15px/1.5 system-ui, -apple-system, "Segoe UI", sans-serif; max-width: 46rem; margin: 0 auto; padding: 1.5rem 1rem 4rem; color: #1b1f24; }
    h1 { font-size: 1.3rem; }
    .meta { color: #5b6570; font-size: 0.85rem; margin-bottom: 1.5rem; }
    @media (prefers-color-scheme: dark) {
        body { background: #16191d; color: #e6e9ed; }
        .meta { color: #9aa4b0; }
    }
`;
